export default __webpack_public_path__ + "static/media/angpao.d633a970.webp";